module.exports = __webpack_public_path__ + "static/img/neutre.8dfb490.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/neutre.png
// module id = bQ6c
// module chunks = 0